module.exports = __webpack_public_path__ + "static/media/fh.0283152a.png";